import React from "react";

function Page({ children, className, ...restProps }) {
  return (
    <div className={`flex flex-col items-center ${className}`} {...restProps}>
      {children}
    </div>
  );
}

export default Page;
